import { owcTheme } from 'core/theme/theme.config';
import { WorkflowOverlayComponent } from 'commons/components';
import styled from 'styled-components';

export const SettingsWorkflowOverlay = styled(WorkflowOverlayComponent)`
    div[slot='content'] {
        display: flex;
        flex-direction: column;
        background-color: ${owcTheme['one-color-gray-50']} !important;
    }
`;
